import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ width, height, viewboxWidth, viewboxHeight, ...rest }) => {
  return (
    <SVGLoader
      {...rest}
      width={width || 17}
      height={height || 15}
      viewboxWidth={viewboxWidth || 17}
      viewboxHeight={viewboxHeight || 15}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.83333 0.669922H15.1667C15.5203 0.669922 15.8594 0.810398 16.1095 1.06045C16.3595 1.31049 16.5 1.64963 16.5 2.00326V11.0033C16.5 11.3569 16.3595 11.696 16.1095 11.9461C15.8594 12.1961 15.5203 12.3366 15.1667 12.3366H8.68667L4.52667 15.2166C4.42948 15.2824 4.31666 15.3213 4.1996 15.3295C4.08255 15.3377 3.9654 15.3148 3.86 15.2633C3.7513 15.2069 3.66021 15.1218 3.59671 15.0171C3.5332 14.9125 3.49975 14.7923 3.5 14.6699V12.3366H1.83333C1.48541 12.3367 1.15123 12.2008 0.902116 11.9579C0.653004 11.715 0.508698 11.3844 0.5 11.0366V2.00326C0.5 1.64963 0.640476 1.31049 0.890524 1.06045C1.14057 0.810398 1.47971 0.669922 1.83333 0.669922ZM4.49999 5.67025H12.5C12.6768 5.67025 12.8464 5.60001 12.9714 5.47499C13.0964 5.34996 13.1667 5.18039 13.1667 5.00358C13.1667 4.82677 13.0964 4.6572 12.9714 4.53218C12.8464 4.40715 12.6768 4.33691 12.5 4.33691H4.49999C4.32318 4.33691 4.15361 4.40715 4.02859 4.53218C3.90357 4.6572 3.83333 4.82677 3.83333 5.00358C3.83333 5.18039 3.90357 5.34996 4.02859 5.47499C4.15361 5.60001 4.32318 5.67025 4.49999 5.67025ZM12.5 8.67025H4.49999C4.32318 8.67025 4.15361 8.60001 4.02859 8.47499C3.90357 8.34996 3.83333 8.18039 3.83333 8.00358C3.83333 7.82677 3.90357 7.6572 4.02859 7.53218C4.15361 7.40715 4.32318 7.33691 4.49999 7.33691H12.5C12.6768 7.33691 12.8464 7.40715 12.9714 7.53218C13.0964 7.6572 13.1667 7.82677 13.1667 8.00358C13.1667 8.18039 13.0964 8.34996 12.9714 8.47499C12.8464 8.60001 12.6768 8.67025 12.5 8.67025Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};
